var _path, _path2, _g, _g2, _g3, _path3, _g4, _path4, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _path5, _rect13;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgTechTableApplicationsFull = function SvgTechTableApplicationsFull(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 480.1 182.3",
    enableBackground: "new 0 0 480.1 182.3",
    xmlSpace: "preserve",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "tech_table_applications_full") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#29526B",
    d: "M287.5,74.7c6.3-6.2,8.1-15.7,4.6-23.8l-15.6,15.6l-7.5-3.3l-3.9-8l15.6-15.6c-8.1-3.5-17.6-1.7-23.8,4.6 c-6.3,6.3-8.1,15.7-4.5,23.9l-23.5,23.5l11.3,11.3l23.6-23.6C271.9,82.8,281.3,81,287.5,74.7z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#29526B",
    d: "M181.5,119.7c-6.3,6.2-8.1,15.7-4.6,23.8l15.6-15.6l7.5,3.3l3.9,8l-15.6,15.6c8.1,3.5,17.6,1.7,23.8-4.6 c6.3-6.3,8.1-15.7,4.5-23.9l23.5-23.6l-11.2-11.3l-23.6,23.6C197.2,111.6,187.8,113.5,181.5,119.7z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M337.9,91.1l11-11.1c0.8-0.9,2.2-1.1,3.2-0.3c0.9,0.6,1.4,1.7,1.3,2.8l-3.2,3.6c0,0-1,1.4,1.1,3.6 s13.5,13.6,13.5,13.6l-4.4,2.1l-13.1-12.5c-1.2-1-2.9-1-4.1,0.1l-2,1.9c0,0-1.5,1.4-3-0.4C337.2,93.6,337.1,92.1,337.9,91.1z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.68
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "#29526B",
    cx: 327.2,
    cy: 143.4,
    r: 16.1
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.68
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "#29526B",
    cx: 372.4,
    cy: 142.9,
    r: 16.1
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#29526B",
    d: "M404.2,107.5c0-7.1-0.4-6.6-3.8-6.7h-16.7c-2.5-0.1-4.6-1.7-5.4-4c0,0-12.6-42.9-14.6-48.8 c-1.8-5.3-8.4-4.8-8.4-4.8s-32.1,0.4-43.6,0.2c-11.2-0.2-10.9,6.7-10.9,6.7s-0.7,76.6-0.6,84.9c0.1,6.5-0.5,7,2.9,7 c1.7,0,5.1,0.1,5.1,0.1s0.8-17.8,18.6-17.6c18.3,0.2,19.2,17.8,19.2,17.8h7.1c0,0,1-17.8,18.5-17.8c19.4,0,19.5,18.3,19.5,18.3 s2.8,0,8.5-0.1c4.7-0.1,4.4-5,4.4-5S404.2,114.6,404.2,107.5z M363.7,100.9c0,0-39.1,0.6-44.5,0.2s-5.1-5.1-5.1-5.1V60.8 c0.1-4.2-0.1-4.8,2.2-4.8c0,0,26.3-0.2,31.6-0.1s5.6,3.1,5.6,3.1l11,38.4C365.5,101,363.7,100.9,363.7,100.9z"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M404.8,30.8c0,0-0.3-2.5,2.7-2.5c1.3-0.1,2.4,0.9,2.5,2.2c0,0.1,0,0.2,0,0.3l0.3,108.8c0,0-0.5,4.4,5.7,4.4 c6.8,0,42.1-0.2,42.1-0.2s3.1-0.4,3.1,2.3c0.2,1.2-0.7,2.4-2,2.5c-0.2,0-0.4,0-0.6,0l-51.3,0.4c-2.3,0-2.4-0.8-2.3-6.5 C405.2,135.5,404.8,30.8,404.8,30.8z"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#29526B",
    d: "M86.5,56.6v82h82v-82H86.5z M164.5,134.5H90.6V60.6h73.9V134.5z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 124.2,
    y: 60,
    fill: "#29526B",
    width: 5.5,
    height: 16.8
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 109,
    y: 102.1,
    fill: "#FF931E",
    width: 3.1,
    height: 25.6
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 114.4,
    y: 102.1,
    fill: "#FF931E",
    width: 4.1,
    height: 25.6
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 120.2,
    y: 102.1,
    fill: "#FF931E",
    width: 1.4,
    height: 25.6
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 123.9,
    y: 102.1,
    fill: "#FF931E",
    width: 3.1,
    height: 25.6
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 129.3,
    y: 102.1,
    fill: "#FF931E",
    width: 4.1,
    height: 25.6
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 135.1,
    y: 102.1,
    fill: "#FF931E",
    width: 1.4,
    height: 25.6
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 138,
    y: 102.1,
    fill: "#FF931E",
    width: 1.4,
    height: 25.6
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 141.1,
    y: 102.1,
    fill: "#FF931E",
    width: 1.4,
    height: 25.6
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 153.1,
    y: 102.1,
    fill: "#FF931E",
    width: 3.1,
    height: 25.6
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 146.7,
    y: 102.1,
    fill: "#FF931E",
    width: 4.1,
    height: 25.6
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 143.6,
    y: 102.1,
    fill: "#FF931E",
    width: 1.4,
    height: 25.6
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#29526B",
    d: "M43.6,45.4c6.2,0,11.3-5.1,11.3-11.3c0-6.2-5.1-11.3-11.3-11.3c-6.2,0-11.3,5.1-11.3,11.3 C32.3,40.3,37.3,45.4,43.6,45.4z M55.3,47.9H31.5c-8,0-14.5,6.6-14.4,14.6c0,0,0,0,0,0.1v34.7c0,6.7,9.9,6.7,9.9,0V65.5h2.3v86.8 c0,9,13.1,8.7,13.1,0v-50.4h2.3v50.4c0,8.7,13.2,9,13.2,0V65.5h2.3v31.7c0,6.8,9.8,6.8,9.8,0V62.7C70,54.6,63.5,47.9,55.3,47.9 C55.4,47.9,55.4,47.9,55.3,47.9L55.3,47.9z"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    y: 0,
    fill: "none",
    width: 480.1,
    height: 182.3
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgTechTableApplicationsFull);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/tech_table_applications_full.6db01103882d339b1438ea6114a264dd.svg";